export default () => ({
  waiting: false,

  onPick(detail) {
    if (!this.waiting) return

    if (detail.master_id) {
      this.$refs.masterId.value = detail.master_id
      this.$refs.addressId.value = ""
    } else {
      this.$refs.masterId.value = ""
      this.$refs.addressId.value = detail.id
    }
    this.$store.modal?.cancel()
    this.$refs.form.requestSubmit()
    this.waiting = false
  },
})
